import { sandboxT } from './translations';

export const SandboxBadge = () => (
  <span className="inline-flex items-center rounded-md bg-highlight-muted px-2 py-1 text-sm">
    {sandboxT.common.labels.sandbox}
  </span>
);
